import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export interface ISearchLinksContentBlock {
    header: string;
    texts: {
        text: string;
        link: string;
    }[];
}
@Component({
    selector: 'search-links',
    templateUrl: 'search-links.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterLink, CommonModule, ICmsClientModule]
})
@ICmsComponent<SearchLinksComponent>({
    id: 'search-links',
    block: {
        url: 'search-links'
    },
    onDemandOnly: true,
    name: 'Search Links Content Block',
    description: 'Content block used to display links in search outlet',
    fields: [
        <NICmsContentField.IField>{
            key: 'header',
            type: NICmsContentField.EFieldType.text,
            title: 'Header',
            required: true,
            default: 'How can we help'
        },
        <NICmsContentField.IRepeaterField>{
            key: 'texts',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Texts',
            itemName: 'Text',
            itemNameField: 'text',
            fields: [
                <NICmsContentField.IField>{
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Text',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link',
                    required: true
                }
            ],
            default: []
        }
    ]
})
export class SearchLinksComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: ISearchLinksContentBlock;
}
